const getApiUrl = () => {
  return process.env.REACT_APP_API_URL;
};
const getWsUrl = () => {
  return process.env.REACT_APP_WS_URL;
};
export const API_URL = getApiUrl();
export const WS_URL = getWsUrl();